import { useQuery } from "@tanstack/react-query";
import { AxiosRequestConfig } from "axios";

import axios from "../../../utils/axiosInceptor";
import { apiV1Endpoint } from "../endpoints";
import { ApiResponse } from "../types";

import { Organization } from "./types";

export async function getOrganizationById<TResult = Organization>(orgId: string, config?: AxiosRequestConfig) {
  const url = `${apiV1Endpoint}/organization/${orgId}`;

  const response = await axios.get<ApiResponse<TResult>>(url, config);
  return response.data;
}

type UseGetOrganizationByIdOptions = {
  orgId?: string | null;
  params?: Record<string, unknown>;
  isEnabled?: boolean;
};

export function useGetOrganizationById<TResult = Organization>(options: UseGetOrganizationByIdOptions = {}) {
  const { params, isEnabled = true } = options;
  const orgId = options.orgId ?? "";

  const { data, isLoading, isFetching, isSuccess, isError, error, refetch } = useQuery({
    queryKey: ["organizationById", orgId, params ?? null],
    queryFn: ({ signal }) => getOrganizationById<TResult>(orgId, { ...(params ? { params } : {}), signal }),
    enabled: Boolean(orgId) && isEnabled,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    organization: data?.result,
    isLoadingOrganization: isLoading,
    isFetchingOrganization: isFetching,
    isSuccessOrganization: isSuccess,
    isErrorOrganization: isError,
    organizationError: error,
    refetchOrganization: refetch,
  };
}
